import { SpaceConfig } from "./spaceConfig";
import spacesBase from "./spacesBase";

// If user is connected to VS but reporting for other spaces then don’t include all the other VS specific tags which come with the template from native process
// For VS space we'll continue to include all tags sent by native process
// @TODO: Test this list again after verbatim API starts accepting developercommunity as source
const allowedTemplateTagTypesForNonVSSpaces: string[] = [
    "feedbackSessionId",
    "vs-otuid",
    "vote-userid",
    "vsts-displayname",
];

const nonVSSpacesBase: Partial<SpaceConfig> = {
    ...spacesBase,
    reportProblemConfig: {
        ...spacesBase.reportProblemConfig,
        isNativeProcessRequired: false,
        showSeverityOptions: true,
        showRegressionOptions: false,
        allowedTemplateTagTypes: allowedTemplateTagTypesForNonVSSpaces,
    },
    reportSuggestionConfig: {
        ...spacesBase.reportSuggestionConfig,
        isNativeProcessRequired: false,
        showRegressionOptions: false,
        allowedTemplateTagTypes: allowedTemplateTagTypesForNonVSSpaces,
    }
};

export default nonVSSpacesBase;
